/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetCharactersCharacterIdNotFound
 */
export interface GetCharactersCharacterIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetCharactersCharacterIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdNotFound(value: object): value is GetCharactersCharacterIdNotFound {
    return true;
}

export function GetCharactersCharacterIdNotFoundFromJSON(json: any): GetCharactersCharacterIdNotFound {
    return GetCharactersCharacterIdNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdNotFoundToJSON(json: any): GetCharactersCharacterIdNotFound {
    return GetCharactersCharacterIdNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdNotFoundToJSONTyped(value?: GetCharactersCharacterIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

